module.exports = __webpack_public_path__ + "img/expertise_stats.f6b4def5.png";